import React from "react";

import LogoImage from "../../../assets/images/LoginLogo.png";

const LootLedgerHome = (props) => {
  const { children } = props;

  return (
    <div>
      <div className="login-card-wrapper row m-0  min-vh-100 min-vw-100 d-flex">
        {/* LEFT SIDE */}
        <div className="col-12 col-md-6 d-flex flex-column justify-content-center align-items-center text-white left-login-side">
          <img
            className="login-loot-ledger-icon"
            src={LogoImage}
            alt="lootledger icon"
          />
          <div className="text-center">
            <h1 className="m-0">LootLedger</h1>
            <p className="fs-5 mt-4">
              Streamlined Inventory & Collection Tracking
            </p>
          </div>
        </div>

        {/* RIGHT SIDE (LOGIN CARD) */}
        <div className="col-12 col-md-6 d-flex justify-content-center align-items-center position-relative">
          {children}
        </div>
      </div>
    </div>
  );
};

export default LootLedgerHome;
